const customLangs = {
    gb: {
        _name: 'English',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    ru: {
        _name: 'Русский',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    pl: {
        _name: 'Polski',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    cz: {
        _name: 'Čeština',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    de: {
        _name: 'Deutsch',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    fr: {
        _name: 'Français',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        }
    },
    es: {
        _name: 'Español',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    dk: {
        _name: 'Dansk',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    nl: {
        _name: 'Nederlandse taal',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    sa: {
        _name: 'عربي',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    it: {
        _name: 'Italiano',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    sk: {
        _name: 'Slovak',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    hu: {
        _name: 'Hungarian',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    ro: {
        _name: 'Romanian',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    ge: {
        _name: 'Georgia',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    az: {
        _name: 'Azerbaijani',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    tr: {
        _name: 'Türkçe',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    rs: {
        _name: 'Srpski',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    pt: {
        _name: 'Português',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    jp: {
        _name: '日本語',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    hr: {
        _name: 'Hrvatski',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    kz: {
        _name: 'Қазақ тілі',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    kg: {
        _name: 'Кыргыз тили',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    },
    cn: {
        _name: '中文',
        autoTrader: {
            title: {
                lexiumlimited: 'AI Nexus Protocol'
            }
        },
        newDesign: {
            other: {
                trustisag: "Einkommensnachweis"
            },
            otherDocuments: {
                trustisag: "Letzte Lohnabrechnung oder letzter Rentenbescheid.<br>Falls Sie eine Rente beziehen und zusätzlich arbeiten, laden Sie bitte beide Dokumente hoch.<br>Diese Angaben werden zur Deklaration Ihrer Einkünfte aus dem Handel an der Börse benötigt."
            },
            savingsAccounts: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            },
        },
        fullScreen: {
            savings: {
                canadatokentrade: 'Savings/IPO/ICO',
                avxsolutions: 'Savings/IPO/ICO',
            }
        },
    }
}

export default customLangs
